import React, { useState,useRef } from 'react';
import styled from 'styled-components';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export const EditorWrapDiv = styled.div`
  margin-bottom: 67px;

  & > div {
    & div:first-child {
      border-top-right-radius: 6px;
      border-top-left-radius: 6px;
    }
    & div:last-child {
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
    }
  }
`;

export const CompactEditorWrap = styled.div`
  width: 100%;
  max-width: 100%;
  margin-bottom: 0;
  box-sizing: border-box;

  .quill {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border: 1px solid #E5E7EB;
    border-radius: 8px;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
  }

  .ql-toolbar.ql-snow {
    border: none;
    border-bottom: 1px solid #E5E7EB;
    border-radius: 8px 8px 0 0;
    background: #FAFBFC;
    width: 100%;
    box-sizing: border-box;
    padding: 6px 8px;
    flex-wrap: wrap;
  }

  .ql-container.ql-snow {
    border: none;
    border-radius: 0 0 8px 8px;
    width: 100%;
    box-sizing: border-box;
    height: ${props => props.editorHeight || '130px'};
    min-height: ${props => props.editorHeight || '130px'};
    font-size: 14px;
  }

  .ql-editor {
    min-height: ${props => props.editorHeight || '130px'};
    height: 100%;
    box-sizing: border-box;
    word-break: break-word;
    overflow-wrap: anywhere;
    padding: 12px 14px;
  }

  .ql-editor.ql-blank::before {
    color: #9CA3AF;
    font-style: normal;
  }

  .ql-editor img {
    max-width: 100%;
    height: auto;
  }
`;

export const EditorErrorText = styled.p`
  margin: 8px 0 0;
  color: #E74C3C;
  font-size: 12px;
  line-height: 1.4;
`;

const QUILL_MODULES = {
  toolbar: {
    container: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      [
        { 'color': ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"] },
        { 'background': ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"] },
      ],
      ['image'],
      ['clean'],
    ],
  },
};

const QUILL_FORMATS = [
  'header',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent', 'color', 'background',
  'link', 'image',
];

const RichQuestionEditor = (props) => {
  const { height, width, id, value, change, compact, placeholder } = props;
  const [errorMessage, setErrorMessage] = useState(null);

  const quillRef = useRef(null);

  const checkHtmlSize = (html) => {
    // Convert HTML content to Blob
    const blob = new Blob([html], { type: 'text/html' });
    const htmlSize = blob.size;

    // Extract images from HTML and calculate their sizes
    const imgTags = html.match(/<img [^>]*src="[^"]*"[^>]*>/gm);
    let imgSize = 0;

    if (imgTags) {
      imgTags.forEach((imgTag) => {
        const src = imgTag.match(/src="([^"]*)"/)[1];
        if (src.startsWith('data:image')) {
          // Base64 image size calculation
          const base64Str = src.split(',')[1];
          const base64Size = (base64Str.length * (3 / 4)) - (base64Str.endsWith('==') ? 2 : base64Str.endsWith('=') ? 1 : 0);
          imgSize += base64Size;
        }
      });
    }

    const totalSize = htmlSize + imgSize;

    if (totalSize > 1 * 1024 * 1024) {
      console.error('HTML content including images exceeds 1MB');
    //   alert('HTML content including images exceeds 1MB');
      setErrorMessage('Content including images exceeds 1MB,Please change image or resize it.')
    } else {
      console.log('HTML content size is within limits');
      setErrorMessage(null)
    }
  };


// const handleImageUpload = (file) => {
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       const base64Str = e.target.result.split(',')[1];
//       const base64Size = (base64Str.length * (3 / 4)) - (base64Str.endsWith('==') ? 2 : base64Str.endsWith('=') ? 1 : 0);
//       const currentHtml = quillRef.current.getEditor().root.innerHTML;
//       const blob = new Blob([currentHtml], { type: 'text/html' });
//       const htmlSize = blob.size;

//       if (htmlSize + base64Size > 1 * 1024 * 1024) {
//         setErrorMessage('Content size exceeds 1MB. Image upload is not allowed.');
//       } else {
//         setErrorMessage('');
//         const quillEditor = quillRef.current.getEditor();
//         const range = quillEditor.getSelection();
//         quillEditor.insertEmbed(range.index, 'image', e.target.result);
//       }
//     };
//     reader.readAsDataURL(file);
//   };

//   const imageHandler = () => {
//     const input = document.createElement('input');
//     input.setAttribute('type', 'file');
//     input.setAttribute('accept', 'image/*');
//     input.click();

//     input.onchange = () => {
//       const file = input.files[0];
//       if (file) {
//         handleImageUpload(file);
//       }
//     };
//   };

  const valueChange = (val) => {
    if (typeof val === 'string') {
      checkHtmlSize(val);
    }
    if (change) change(id, val);
  }

  if (compact) {
    return (
      <CompactEditorWrap style={{ width: width }} editorHeight={height ? `${height}px` : '130px'}>
        <ReactQuill
          theme="snow"
          ref={quillRef}
          modules={QUILL_MODULES}
          formats={QUILL_FORMATS}
          value={value}
          onChange={valueChange}
          placeholder={placeholder}
        />
        {errorMessage ? <EditorErrorText>{errorMessage}</EditorErrorText> : null}
      </CompactEditorWrap>
    );
  }

  return (
    <>
    <EditorWrapDiv style={{ width: width }}>
      <ReactQuill
        theme="snow"
        ref={quillRef}
        modules={QUILL_MODULES}
        formats={QUILL_FORMATS}
        value={value}
        onChange={valueChange}
        style={{ height: height }}
      />
    </EditorWrapDiv>
    <p style={{marginTop:-10,color:'red'}}>{errorMessage}</p>
    </>
  );
}

export default RichQuestionEditor;